import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useAuth } from "@/contexts/AuthContext";
import { useI18n } from "@/contexts/I18nContext";

export default function AdminLogin() {
  const { t } = useI18n();
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Connexion réussie");
      navigate("/admin");
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-100">
      {/* Left panel */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 bg-brand-navyDeep text-white overflow-hidden">
        <div className="absolute inset-0 opacity-25">
          <img src="https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1600&q=80" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-br from-brand-navyDeep via-brand-navy/85 to-transparent" />
        </div>
        <div className="relative z-10">
          <Logo variant="light" size="lg" withTag />
        </div>
        <div className="relative z-10">
          <div className="text-xs uppercase tracking-[0.28em] text-brand-orange font-semibold">Espace Owner</div>
          <h2 className="mt-4 font-display text-4xl leading-tight">Le cockpit de votre entreprise.</h2>
          <p className="mt-4 text-white/70 max-w-md">CRM, opérations, facturation et inventaire — tout au même endroit.</p>
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8"><Logo /></div>
          <div className="flex items-center justify-between mb-8">
            <div>
              <div className="text-xs uppercase tracking-[0.28em] text-brand-orange font-semibold">Team Work</div>
              <h1 className="mt-2 font-display text-3xl text-brand-navy">{t("admin.login")}</h1>
            </div>
            <LanguageSwitcher />
          </div>

          <form onSubmit={submit} className="space-y-5 bg-white border border-slate-200 rounded-lg p-8 shadow-sm" data-testid="login-form">
            <div>
              <Label htmlFor="email">{t("admin.email")}</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
            </div>
            <div>
              <Label htmlFor="password">{t("admin.password")}</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-brand-orange hover:bg-brand-orangeDark text-white h-11" data-testid="login-submit">
              {loading ? "…" : t("admin.signIn")}
            </Button>
          </form>

          <Link to="/" className="mt-6 block text-center text-xs uppercase tracking-widest text-slate-500 hover:text-brand-navy">
            ← Retour au site
          </Link>
        </div>
      </div>
    </div>
  );
}
